import menu from './Profile_menu';
import breadcrumbs from './Profile_breadcrumbs';
import user from './Profile_user';
import other_user from './Profile_other_user';
import modals from './Profile_modals';
import statuses from './Profile_control_admin_statuses';
import general from './Profile_general';

export default {
  namespaced: true,
  modules   : {
    menu,
    breadcrumbs,
    user,
    other_user,
    modals,
    statuses,
    general,
  },

};
